<app-splash-screen></app-splash-screen>
<app-offline-indicator></app-offline-indicator>
<app-update-notification></app-update-notification>
<router-outlet></router-outlet>